import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const links = [
  { label: "Sound", href: "#sound" },
  { label: "Manifesto", href: "#manifesto" },
  { label: "Transmission", href: "#transmission" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.6, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-ink/80 backdrop-blur-md border-b border-line" : "bg-transparent"
      }`}
      data-testid="site-nav"
    >
      <div className="flex items-center justify-between px-5 sm:px-8 lg:px-12 py-4">
        <a href="#top" data-testid="nav-logo" className="font-display font-black text-bone text-lg tracking-tighter uppercase leading-none">
          zi<span className="text-acid">.</span>enzi
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-bone/60 hover:text-acid transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
          <a
            href="https://crackheadbeats.dance"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-crackheadbeats"
            className="group font-mono text-[10px] sm:text-xs uppercase tracking-[0.18em] text-bone border border-line px-3 py-2 hover:border-acid hover:text-acid transition-colors duration-300"
          >
            crackheadbeats.dance <span className="inline-block group-hover:translate-x-1 transition-transform duration-300">↗</span>
          </a>
          <a
            href="https://noisetrance.dance"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-noisetrance"
            className="group font-mono text-[10px] sm:text-xs uppercase tracking-[0.18em] text-ink bg-acid px-3 py-2 hover:bg-blood hover:text-bone transition-colors duration-300"
          >
            noisetrance.dance <span className="inline-block group-hover:translate-x-1 transition-transform duration-300">↗</span>
          </a>
        </div>
      </div>
    </motion.header>
  );
};

export default Nav;
